const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var FlagCa16 = function FlagCa16(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M.5 3.9a1.4 1.4 0 0 1 1.4-1.4h12.2a1.4 1.4 0 0 1 1.4 1.4v7.55a1.4 1.4 0 0 1-1.4 1.4H1.9a1.4 1.4 0 0 1-1.4-1.4V3.9z",
      fill: "red",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M4.25 2.5h7.5v10.35h-7.5V2.5zm3.89 8.458-.07-1.396a.158.158 0 0 1 .05-.122.147.147 0 0 1 .124-.036l1.342.244-.181-.518a.109.109 0 0 1 .03-.118l1.471-1.232-.331-.16a.104.104 0 0 1-.05-.053.108.108 0 0 1-.003-.075l.29-.925-.846.186a.099.099 0 0 1-.068-.01.104.104 0 0 1-.046-.051l-.165-.4-.66.735a.099.099 0 0 1-.12.021A.103.103 0 0 1 8.861 7a.108.108 0 0 1-.009-.066l.319-1.7-.511.305a.1.1 0 0 1-.142-.044L8 4.441l-.519 1.054a.105.105 0 0 1-.062.054.098.098 0 0 1-.08-.01l-.51-.306.318 1.701A.108.108 0 0 1 7.138 7a.103.103 0 0 1-.044.048.099.099 0 0 1-.12-.021l-.662-.735-.164.4a.104.104 0 0 1-.046.052.099.099 0 0 1-.068.01l-.846-.187.29.925a.109.109 0 0 1-.003.075.104.104 0 0 1-.05.053l-.331.16 1.47 1.232a.109.109 0 0 1 .031.118l-.18.518 1.341-.244a.144.144 0 0 1 .124.036.154.154 0 0 1 .05.122l-.07 1.396h.28z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.882 2h12.236C15.158 2 16 2.843 16 3.882v7.53c0 1.04-.843 1.882-1.882 1.882H1.882A1.882 1.882 0 0 1 0 11.412v-7.53C0 2.842.843 2 1.882 2zm0 .47c-.78 0-1.411.633-1.411 1.412v7.53c0 .78.632 1.411 1.411 1.411h12.236a1.41 1.41 0 0 0 1.411-1.411v-7.53a1.41 1.41 0 0 0-1.411-1.411H1.882z",
      fill: "#D8DDE1",
    })
  );
};
FlagCa16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  16: FlagCa16,
};
export function FlagCa(_ref) {
  let { size = "16" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["16"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'FlagCa' icon. Please use one of the available sizes: '16'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
